import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onBeforeUnmount, ref, PropType } from 'vue';
import { useModelValue } from "../../../composables/useSyncProp";
import { FifScript } from './FIFSurvey/FifScripts';
import FIFSurveyForm from './FIFSurvey/FIFSurveyForm.vue';

import { quickQuestions } from './FIFSurvey/questions';


export default /*#__PURE__*/_defineComponent({
  __name: 'FIFDirectToReset',
  props: {
	value: {
		type: Boolean as PropType<boolean>,
		required: true,
	},
	eventBus: {
		type: Object,
		default: () => ({}),
	}
},
  emits: ["input", "qrs-confirmed", "sme-confirmed", "scriptFinished"],
  setup(__props, { emit }: { emit: ({
	(event: 'input', value: boolean): void
	(event: 'qrs-confirmed'): void
	(event: 'sme-confirmed', value: any): void
	(event: 'scriptFinished', value: FifScript): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const selectedScript = ref<FifScript | null>(null);





const doShow = useModelValue(props, emit)

const clearFormSelect = () => {
	selectedScript.value = null
}

onMounted(() => {
    props.eventBus.$on?.('clear-form-select', clearFormSelect )
})

onBeforeUnmount(() => {
    props.eventBus.$off?.('clear-form-select', clearFormSelect )
})

const scripts = computed(() => {
    const scripts: Record<FifScript, boolean> =  {
      DFL: false,
      QRS: false,
      IUL: false,
      IBC: false,
      Annuity: false,
    };

    selectedScript.value && (scripts[selectedScript.value] = true)

    return scripts;
})

const selectOptions = [
	{ text: 'DFL: (Debt Free Life) Client is interested in eliminated debt', value: 'DFL', description: ['Debt Free Life.', 'DFL pays off the client\'s debt in 1/2 the time with no additional money out of pocket'] },
    { text: 'IBC: (Infinite Banking Concept) Client is interested in taking control of their finances (be their own bank)', value: 'IBC', description: ['Infinite Banking Concept.', 'Provides the client the opportunity to be their own bank'] },
    { text: 'IUL: (Indexed Universal Life) Client is interested in a Tax-Advantaged income to supplement retirement', value: 'IUL', description: ['Indexed Universal Life.', 'Provides clients with tax-advantaged, low market-risk income to supplement retirement'] },
    // QFA is under construction per Resma & we will remove agent-facing resources/access for QFA from agent view
    // { text: 'QFA: Financial Advisor/Guidance', value: 'QRS', description: ['QFA.', 'Clients that don\'t have debt and at least $20,000+ of assets in any current or old retirement account'] },
    { text: 'Annuity: Client is interested in protecting their current retirement/investment from market risk (Loss)', value: 'Annuity', description: ['Annuity.', 'Clients that don\'t have debt and at least $20,000+ of assets in an old retirement account'] },
];

return { __sfc: true,selectedScript, props, emit, doShow, clearFormSelect, scripts, selectOptions, FIFSurveyForm, quickQuestions }
}

})